















































import Vue from 'vue';
import BtNumberField from './BtNumberField.vue';

export default Vue.extend({
    name: 'BtTillgangarSkulderContent',
    components: {
        BtNumberField,
    },
    props: {
        componentId: {
            type: String,
            required: true,
        },
        realEstateValueAccount: {
            type: String,
            required: true,
        },
        realEstateValuePaper: {
            type: String,
            required: true,
        },
        realEstateValueOther: {
            type: String,
            required: true,
        },
        realEstateValueLiabilities: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            id: 'btTillgangarSkulderContent',
            skulderData: {
                realEstateValueAccount: this.realEstateValueAccount,
                realEstateValuePaper: this.realEstateValuePaper,
                realEstateValueOther: this.realEstateValueOther,
                realEstateValueLiabilities: this.realEstateValueLiabilities,
            },
            validation: {
                pengar: {
                    minValue: { minValue: 0 },
                    maxValue: { maxValue: 99999999 },
                },
                reqpengar: {
                    required: { errorMessage: this.$t('SBRV.RW.pengarfalt.etikett.fyllipengarfalt') },
                    minValue: { minValue: 0 },
                    maxValue: { maxValue: 99999999 },
                },
            },
        };
    },
    methods: {
        emit() {
            this.$emit('on-edit-emit', this.skulderData);
        },
    },
});
